/**
 * Opening resolved links (button-load-url, link transforms): app routes through the router
 * (overlay / same tab), new tabs and external URLs with noopener + noreferrer. The router is
 * registered by main.ts so elements and grid cells need no router instance of their own.
 */
import type { LinkHost, LinkTarget, ResolvedLink } from '@creator/plugins-sdk/client';
import type { Router } from 'vue-router';

let router: Router | undefined;

export function setLinkRouter(r: Router): void {
  router = r;
}

export function openLink(link: ResolvedLink, target: LinkTarget): void {
  if (link.kind === 'external') {
    window.open(link.href, '_blank', 'noopener,noreferrer');
    return;
  }
  if (target === 'blank' || !router) {
    window.open(link.path, '_blank', 'noopener');
    return;
  }
  void router.push(link.path);
}

export const linkHost: LinkHost = { open: openLink };
